{
  "fr": {
    "meta": {
      "description": "FleetYards.net, votre base de données pour toutes les informations relatives aux vaisseaux de « Star Citizen »."
    },
    "model": {
      "focus": "Domaine",
      "classification": "Classification",
      "size": "Taille",
      "beam": "Rayon",
      "cargo": "Soute",
      "cargoWithModules": "avec modules",
      "additionalStorage": {
        "salvage": "+%{capacity} SCU de récupération",
        "ore": "+%{capacity} SCU de minerai"
      },
      "personalInventory": "Inventaire du vaisseau",
      "beds": {
        "one": "%{count} lit",
        "other": "%{count} lits"
      },
      "crew": "Équipage",
      "speed": "Vitesse",
      "scmSpeed": "Vitesse SCM",
      "scmSpeedBoosted": "Vitesse SCM Boostée",
      "reverseSpeedBoosted": "Vitesse Marche Arrière Boostée",
      "maxSpeed": "Vitesse Max",
      "scm": "SCM",
      "max": "Max",
      "groundMaxSpeed": "Vitesse Max",
      "groundReverseSpeed": "Vitesse Marche Arrière",
      "pitch": "Pitch",
      "pitchBoosted": "Pitch Boosté",
      "yaw": "Yaw",
      "yawBoosted": "Yaw Boosté",
      "roll": "Roll",
      "rollBoosted": "Roll Boosté",
      "price": "Prix",
      "groundAcceleration": "Accélération",
      "compare": {
        "groundMaxSpeed": "Vitesse Sol Max",
        "groundReverseSpeed": "Vitesse Sol Marche Arrière",
        "groundAcceleration": "Accélération Sol",
        "groundDeceleration": "Décélération Sol"
      },
      "pledgePrice": "Prix réel",
      "quantumFuelTankSize": "Carburant Quantum",
      "hydrogenFuelTankSize": "Carburant",
      "height": "Hauteur",
      "length": "Longueur",
      "mass": "Masse",
      "manufacturer": "Fabricant",
      "hardpoints": "point d'ancrage",
      "weapons": "Armes",
      "equipment": "Équipement",
      "variants": "Variantes",
      "productionStatus": "Statut du produit",
      "propulsion": "Propulsion",
      "modular": "Modulaire",
      "soldAt": "Vendu à?",
      "rentalAt": "Location à ?",
      "poweredByUex": "Propulsé par UEX",
      "lastUpdatedAt": "Dernière mise à jour le ?"
    },
    "component": {
      "manufacturer": "Fabricant",
      "size": "Taille"
    },
    "availability": {
      "soldAt": "Vendu à",
      "boughtAt": "Acheté à"
    },
    "resources": {
      "models": "Vaisseaux",
      "hardpoints": "Points d'ancrage",
      "images": "Images"
    },
    "pagination": {
      "previous": "Page précédente",
      "next": "Page suivante",
      "gap": "écart entre les lignes"
    }
  }
}
